import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    $(this.element).select2({
      width: "100%",
      placeholder: this.element.dataset.placeholder,
      theme: "date",
      allowClear: false,
      minimumResultsForSearch: -1
    });
  }
}
